import { SvgIconDefinition } from '@am/icons-common-types';
const width = 128;
const height = 128;
const path = `M113.145,37.92H6.984c-1.437,0-2.867,1.198-2.613,2.612l6.13,34.013c1.359,7.543,6.284,13.937,13.937,13.937h71.253c7.653,0,12.58-6.406,13.937-13.937l6.13-34.013C116.011,39.125,114.582,37.92,113.145,37.92z M115.821,26.77H87.543L62.784,1.131c-0.737-0.764-1.73-1.142-2.72-1.131c-0.99-0.011-1.982,0.367-2.72,1.131L32.585,26.77H4.308C1.938,26.77,0,28.708,0,31.078v0c0,2.369,1.938,4.308,4.308,4.308h111.513c2.369,0,4.308-1.938,4.308-4.308v0C120.129,28.708,118.19,26.77,115.821,26.77z M42.93,26.77L60.064,9.027L77.199,26.77H42.93z`;

export const aciPicnicArea: SvgIconDefinition = {
  iconName: 'picnic-area',
  iconData: [height, width, path],
};
